// Models
import { I_ProfileBtns } from "../Models/interfaces";
// Models

import { FiMessageSquare } from "react-icons/fi";
import { AiOutlineFilePdf, AiOutlineEdit } from "react-icons/ai";
import { MdExitToApp } from "react-icons/md";
import { BsTelephoneFill, BsJournalBookmark } from "react-icons/bs";
import Swal from "sweetalert2";
import { axiosV3 } from "../Utils/Axios/axiosV3";

export const profileBtns: I_ProfileBtns[] = [
  {
    backgroundGradient:
      " linear-gradient( rgb(227 ,97 ,249) -50%  , rgb(169 , 50 , 190) )",
    Icon: FiMessageSquare,
    name: "پیام ها",
    routeToNavigate: "/profile/messages",
    borderGradiant: "rgb(169 , 50 , 190)",
  },
  {
    backgroundGradient:
      "linear-gradient(45deg, rgb(60 , 224, 92) , rgb(11 ,201  ,47 ) )",
    Icon: AiOutlineFilePdf,
    name: "فایل ها",
    routeToNavigate: "/profile/files",
    borderGradiant: "rgb(11 ,201  ,47 )",
  },
  {
    backgroundGradient:
      "linear-gradient(45deg, rgb(71 ,173 ,255) , rgb(14 ,148  ,255 ) )",
    Icon: AiOutlineEdit,
    name: " ویرایش مشخصات",
    routeToNavigate: "/profile/edit",
    borderGradiant: "rgb(14 ,148  ,255 )",
  },
  {
    backgroundGradient:
      "linear-gradient(45deg, rgb(255 ,118 ,89) , rgb(255 ,47  ,17 ) )",
    Icon: MdExitToApp,
    name: " خروج",
    routeToNavigate: "",
    borderGradiant: "rgb(255 ,47  ,17 )",
    onClick: () => {
      Swal.fire({
        icon: "info",
        title: "آیا خارج می شوید ؟",
        cancelButtonText: "انصراف",
        confirmButtonText: "خروج",
        showCancelButton: true,
      }).then(({ isConfirmed }) => {
        if (isConfirmed) {
          setTimeout(() => {
            axiosV3
              .get("/user/logout")
              .then(() => {
                console.log("done Exts");
              })
              .finally(() => {
                localStorage.removeItem("amoozeshMeliToken");
                window.location.reload();
              });
          }, 500);
          return;
        }
      });
    },
  },
  {
    backgroundGradient:
      "linear-gradient(45deg, rgb(103 ,127 ,168) , rgb(97 ,133  ,190 ) )",
    Icon: BsTelephoneFill,
    name: " تماس با ما",
    routeToNavigate: "/profile/contact-us",
    borderGradiant: "rgb(97 ,133  ,190 )",
  },
  {
    backgroundGradient:
      "linear-gradient(45deg, rgb(255 ,150 ,87) , rgb(255 ,108  ,20 ) )",
    Icon: BsJournalBookmark,
    name: " قوانین و مقررات",
    routeToNavigate: "/profile/eula",
    borderGradiant: "rgb(255 ,108  ,20 )",
  },
];
